const PropTypes = require('prop-types');
const React = require('react');
const formatAmount = require('../shared/format_amount.js');

const Savings = ({ price, discountedPrice, symbol, bundledProductsCount }) => {
  const savings = price - discountedPrice;

  if (!savings) {
    return null;
  }

  const savingsText = I18n.t('js.productBundles.promo.savings', {
    amount: formatAmount({ amount: savings, symbol }),
    count: bundledProductsCount,
    totalCount: bundledProductsCount + 1,
  });

  return <p className="strong muted size-90 mb-0">{savingsText}</p>;
};

Savings.propTypes = {
  price: PropTypes.number.isRequired,
  discountedPrice: PropTypes.number,
  symbol: PropTypes.string.isRequired,
  bundledProductsCount: PropTypes.number.isRequired,
};

module.exports = Savings;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/savings.jsx